import { type FormInstance, type Rule } from "antd/lib/form"
import { checkMaxNumber, checkMinNumber } from "~Components/forms/rules/utils.rules"

export const createVendorFilterRules = (formInstance: FormInstance) => ({
    minExpenses: [
        {
            validator: (_rule, value: number | string) => checkMinNumber({ formInstance, value, name: "maxExpenses" }),
        },
    ] as Array<Rule>,
    maxExpenses: [
        {
            validator: (_rule, value: number | string) => checkMaxNumber({ formInstance, value, name: "minExpenses" }),
        },
    ] as Array<Rule>,
    minCreditorNumber: [
        {
            validator: (_rule, value: number | string) => checkMinNumber({ formInstance, value, name: "maxCreditorNumber" }),
        },
    ] as Array<Rule>,
    maxCreditorNumber: [
        {
            validator: (_rule, value: number | string) => checkMaxNumber({ formInstance, value, name: "minCreditorNumber" }),
        },
    ] as Array<Rule>,
})
